import variablesSass from "./home.scss";
export default {
  variablesSass
};
